<footer class="app-footer">
  <p>&copy; {{ year }} Tand HN - Todos los derechos reservados</p>
</footer>
